module.exports = new __parcel__URL__("ogre.befc24a7.webp").toString();